import { Component, ViewChild, OnInit, TemplateRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { forkJoin, from, of } from 'rxjs';
import { concatMap, tap, finalize, catchError } from 'rxjs/operators';
import { qmsService } from '../qms.service';

@Component({
  selector: 'app-impact-assessment',
  templateUrl: './impact-assessment.component.html',
  styleUrls: ['./impact-assessment.component.scss']
})

export class ImpactAssessmentComponent implements OnInit {

  refNo: any;

  impactFields: any = [];
  field: any = {};

  isProcessing: boolean = false;
  isAdding: boolean = false;

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    readonly qualityService: qmsService,
    readonly message: messageService,

    private readonly dialog: MatDialog,
    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
  ) {
    this.refNo = this.qualityService.activityId;

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  template: any = [];

  templateList: any = [];
  fieldTypeList: any = [];
  criteriaList: any = [];

  templateDropDown: any = [];
  fieldTypeDropDown: any = [];

  templateSearchText: string = '';
  fieldTypeSearchText: string = '';
  dropDownSearchText: string = '';
  selectedOption: string = '';

  ngOnInit() {
    this.isProcessing = true;
    this.qualityService.isChangeDetectedInOos = false;
    this.impactFields = [];
    this.getTemplate();
    this.loadFieldTypes();
    this.loadImpactFields();
  }

  private getTemplate() {
    this.appService.getAllImpactAssessmentTemplateByModule(this.qualityService.moduleName).subscribe((template: any) => {
      this.templateList = template;
      this.selectBoxForTemplate();
      this.isProcessing = false;
    })
  }

  private selectBoxForTemplate() {
    this.templateDropDown = this.templateList?.map((type: any) => ({
      valueExp: type.templateId,
      displayExp: type.templateName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.templateSelection = this.templateDropDown.length == this.template.length;
      })
    }
  }

  private loadFieldTypes() {
    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_FIELDTYPE").subscribe((type: any) => {
      this.fieldTypeList = type;
      this.selectBoxForFieldType();
    });
  }

  private selectBoxForFieldType() {
    this.fieldTypeDropDown = this.fieldTypeList?.filter((f: any) => f.codelistName != 'Document Repository')?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('field-type', item);
    }
  }

  private loadImpactFields() {
    this.appService.getAllImpactsByRefNo(this.refNo)
      .subscribe((fields: any) => {
        if (!fields?.length) return;

        fields.forEach((el: any) => {
          el.fieldValues = el.fieldValues?.split(',') ?? null;

          if (['Drop Down', 'Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button', 'Vertical Radio Button', 'Horizontal Radio Button'].includes(el.fieldTypeCode)) {
            el.dd = el.response ? el.response.split(',') : [];
          }
        });

        this.impactFields = fields;
        this.isProcessing = false;
      });
  }

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus() }, 0)
  }

  getColWidth(t: any): string {
    if (t === 'Large Text') return 'col-md-6';
    else if (t === 'Multiselect Drop Down') return 'col-md-6';
    else return 'col-md-3';
  }

  popupTitle: string = '';
  openAddFieldPopup() {
    this.popupTitle = 'Add Impact Assessment(s)';
    this.criteriaList = ['Choose from Template', 'Add Manually'];
    this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
  }

  closeAddFieldPopup() {
    this.visibleAddPopup.close();
  }

  onPrimaryOptionChange(event: any) {
    if (event.value == 'Choose from Template') {
      this.template = [];
    }
  }

  addFromTemplate() {
    this.isProcessing = true;

    const calls = this.template.map((id: any) =>
      this.appService.geAllImpactAssessmentFieldsByTemplateId(id)
    );

    forkJoin(calls).subscribe((results: any) => {

      this.impactFields = results.flat();

      this.impactFields.forEach((element: any) => {
        element.isActive = element.isActive === "Y";
      });

      this.create();
      console.log("impactFields →", this.impactFields);
    });

  }

  responses: any[] = [];
  create() {
    const fields = this.impactFields?.filter((field: any) => field.isActive) ?? [];

    if (!fields.length) return;

    this.isAdding = true;
    this.responses = [];

    from(fields).pipe(
      concatMap((field: any, index: number) => {

        if (field.fieldTypeCode === 'Drop Down' || field.fieldTypeCode === 'Multiselect Drop Down' || field.questionTypeCode === 'Vertical Checkbox Button' || field.questionTypeCode === 'Horizontal Checkbox Button' || field.questionTypeCode === 'Vertical Radio Button' || field.questionTypeCode === 'Horizontal Radio Button') {
          field.response = field.response?.length ? field.response.join(',') : null;
        } else if (field.fieldTypeCode === 'Date Field') {
          field.response = field.response ? new Date(field.response) : null;
        }

        const obj = {
          fieldName: field.fieldName,
          fieldTypeCode: field.fieldTypeCode,
          fieldValues: field.fieldValues,
          module: this.qualityService.moduleName,
          response: null,
          justification: null,
          remarks: null,
          refNo: this.refNo
        };

        console.log("Sending →", obj);

        return this.appService.createImpactAssessment(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleAddPopup.close();
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();
  }

  update() {

    this.qualityService.isChangeDetectedInOos = false;
    if (!this.impactFields.length) return;

    const mandatoryList = this.impactFields?.filter((field: any) => {
      if (['Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button'].includes(field.fieldTypeCode)) {
        field.response = field?.dd?.length ? field.dd.join(',') : null;
      } else if (field.fieldTypeCode === 'Date Field') {
        field.response = field.dd ? new Date(field.dd) : null;
      }

      return !field.justification || !field.response;
    });

    if (mandatoryList.length) {
      setTimeout(() => {
        this.showSnackBar('Please enter all Mandatory Fields!', 'E');
      }, 100);
      return;
    }

    this.isProcessing = true;
    this.isAdding = false;
    this.responses = [];

    from(this.impactFields).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          fieldId: field.fieldId,
          fieldSeq: field.fieldSeq,
          fieldName: field.fieldName,
          fieldTypeCode: field.fieldTypeCode,
          fieldValues: field.fieldValues?.join(',') ?? null,
          module: this.qualityService.moduleName,
          response: field.response,
          justification: field.justification,
          remarks: field.remarks,
          refNo: this.refNo
        };

        console.log("Updating →", obj);

        return this.appService.updateImpactAssessment(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Failed to update:", field, error);
            this.showSnackBar("One update failed", "E");
            return of(null);  /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();
  }

  addManually(field: any = {}) {

    const validations = [
      { condition: !field.fieldName, id: 'field-name' },
      { condition: !field.fieldTypeCode, id: 'field-type' },
      ...((field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field') ? [{ condition: !field.fieldValues, id: 'field-values' }] : []),
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar("Please enter all Mandatory Fields!", "E");
    } else {
      this.isProcessing = true;

      const obj = {
        fieldName: field.fieldName,
        fieldTypeCode: field.fieldTypeCode,
        fieldValues: field.fieldValues,
        module: this.qualityService.moduleName,
        response: null,
        justification: null,
        remarks: null,
        refNo: this.refNo
      };
      this.execute(obj);
    }
  }

  execute(obj: any) {
    this.appService.createImpactAssessment(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddPopup.close();
          this.ngOnInit();
        } else {
          this.isProcessing = false;
        }
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  deleteReason: string = '';
  tempArray: any = [];
  parentCheckBox: boolean = false;
  openDeletePopup() {
    this.selectedOption = '';
    this.deleteReason = '';
    this.tempArray = [];
    this.criteriaList = ['Delete All', 'Delete Manually'];
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  closeDeletePopup() {
    this.visibleDeletePopup.close();
  }

  onDeletionOptionChange(event: any) {
    if (event.value == 'Delete Manually') {
      this.parentCheckBox = false;
      this.tempArray = [];
    }
    this.deleteReason = '';
  }

  onParentCheckBoxChanged(e: any) {
    if (e.target.checked) {
      this.parentCheckBox = true;
      this.tempArray = [];
      this.onParentChecked();
    } else {
      this.parentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    for (const c of this.impactFields) {
      c.childCheckBox = true;
      this.tempArray.push({ fieldId: c.fieldId, fieldName: c.fieldName });
    }
  }

  onParentUnChecked() {
    this.impactFields.every((user: any) => {
      user.childCheckBox = false; return true;
    })
    this.tempArray = [];
  }

  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (e.target.checked) {
      childData.childCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.userChildCheckBox = this.parentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checked: any) {
    if (!this.tempArray?.some((x: any) => x.fieldId === checked.fieldId)) {
      this.tempArray.push({
        fieldId: checked.fieldId,
        fieldName: checked.fieldName
      })
    }

    if (this.tempArray?.every((y: any) => y.userChildCheckBox)) this.parentCheckBox = true;
  }

  onChildUnchecked(unchecked: any) {
    const removal = this.tempArray?.findIndex((removable: any) => removable.fieldId == unchecked.fieldId);
    if (removal > -1) this.tempArray?.splice(removal, 1);
  }

  deleteMethod() {
    this.isProcessing = true;
    this.responses = [];

    const array = this.selectedOption == 'Delete All' ? this.impactFields : this.tempArray;

    from(array).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          fieldId: field.fieldId,
          refNo: field.refNo,
          fieldName: field.fieldName,
          deleteReason: this.deleteReason
        };

        console.log("Sending →", obj);

        return this.appService.deleteImpactAssessment(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleDeletePopup.close();
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();
  }


  @ViewChild('templateRef', { static: false }) templateRef: MatSelect;
  templateSelection: boolean = false;
  @ViewChild('multiselect') multiselect: MatSelect;
  multiSelection: boolean = false;

  toggleAllSelection(value: any) {
    if (value == 'template') {
      if (this.templateSelection) this.templateRef.options.forEach((item: MatOption) => item.select());
      else {
        this.templateRef.options.forEach((item: MatOption) => item.deselect())
        this.template = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('template-name', this.template);
      });
    } else if (value == 'multiselect') {
      if (this.multiSelection) this.multiselect.options.forEach((item: MatOption) => item.select());
      else {
        this.multiselect.options.forEach((item: MatOption) => item.deselect());
      }
    }
  }

  onMultiSelect(event: any, item: any, array: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.multiSelection = array.length != item.length;
      })
    }
  }

  onCheckboxChange(event: any, value: string, field: any): void {
    if (event.checked) {
      field.dd.push(value);
    } else {
      let index = field.dd.indexOf(value);
      field.dd.splice(index, 1)
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'category-name');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  @ViewChild('addPopup') addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addPopupConfig = {
    width: '75%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  resultPopupConfig = {
    width: '32%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '75%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  cancelResultPopup() {
    this.visibleResultPopup.close();
    this.ngOnInit();
  }

  changeDetected() {
    this.qualityService.isChangeDetectedInOos = true;
  }

}
